import { councilAppVersionApi } from "@/lib/api"
import { useQuery } from "@tanstack/react-query"

const useGetCouncilAppVersion = (councilId: string) => {
  return useQuery({
    queryKey: [useGetCouncilAppVersion.QUERY_KEY, councilId],
    queryFn: async () => {
      const response = await councilAppVersionApi.getCouncilAppVersion(councilId)
      return response.data.data
    },
    enabled: !!councilId,
  })
}
useGetCouncilAppVersion.QUERY_KEY = "council-app-version"
export default useGetCouncilAppVersion